import { Link } from 'react-router-dom'
import React from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Accordion from 'react-bootstrap/Accordion';
import OffcanvasBody from 'react-bootstrap/OffcanvasBody'
import axios from 'axios';
import { 
  FaFileExport, FaChartLine, FaShoppingCart, FaExchangeAlt, 
  FaBuilding, FaMapMarkerAlt, FaBoxes, FaFileInvoice, 
  FaMoneyBillWave, FaTruck, FaCalculator, FaChartBar,
  FaUsers, FaStore, FaClipboardList, FaUserCircle
} from 'react-icons/fa';

function Sidebar(props) {
  const handleClose = () => {
    props.onChildOffcanClose(false);
  }

  const handleExportUser = () => {
    axios({
      url: 'api/export/user/excel',
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.xlsx');
      document.body.appendChild(link);
      link.click();
      handleClose();
    });
  }

  const handlePbalanceReport = () => {
    axios({
      url: 'api/pbalance',
      method: 'get',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      handleClose();
    });
  }

  const handleOverallRecievableBySalesman = () => {
    axios({
      url: 'api/overallrecievablebysalesman',
      method: 'get',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      handleClose();
    });
  }

  const MenuItem = ({ icon, text, to, onClick }) => {
    const content = (
      <div className='menu-item'>
        {icon}
        <span>{text}</span>
      </div>
    );
    
    if (onClick) {
      return <div onClick={onClick} style={{ cursor: 'pointer' }}>{content}</div>;
    }
    
    return <Link to={to} onClick={handleClose} style={{ textDecoration: 'none' }}>{content}</Link>;
  };

  return (
    <div>
      <Offcanvas 
        show={props.show} 
        className='sidebar-offcanvas' 
        onHide={handleClose} 
        placement='end' 
        scroll='false'
      >
        <Offcanvas.Header closeButton className='sidebar-header'>
          <Offcanvas.Title>
            <div className='header-title'>
              <FaChartLine className='header-icon' />
              <span>Reports & Management</span>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        
        <OffcanvasBody className='sidebar-body'>
          <Accordion className='custom-accordion'>
            
            {/* Reports Section */}
            <Accordion.Item eventKey="8" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaChartBar className='accordion-icon' />
                  <span>Reports</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='/allsaleinvoices' icon={<FaFileInvoice />} text='All Sale Invoices' />
                  <MenuItem to='dailyinvoicessummery' icon={<FaCalculator />} text='Daily Invoices Summery' />
                  <MenuItem to='batchlistinvoices' icon={<FaClipboardList />} text='Batch List Invoices' />
                  <MenuItem to='/gstcustomerreport' icon={<FaBuilding />} text='Customers Gst Tax' />
                  <MenuItem to='all/purchase/invoices' icon={<FaShoppingCart />} text='All Purchase Invoices' />
                  <MenuItem to='/dailybrandsalereport' icon={<FaChartLine />} text='Daily Sale Report' />
                  <MenuItem onClick={handleExportUser} icon={<FaFileExport />} text='Export Users Detail In Excel' />
                  <MenuItem to='stockbystore' icon={<FaBoxes />} text='Closing Stock' />
                  <MenuItem to='salesummerybybrand' icon={<FaChartBar />} text='Profit Report By Sale' />
                  <MenuItem to='pointscheme' icon={<FaCalculator />} text='Point Scheme' />
                  <MenuItem to='stockstatus' icon={<FaBoxes />} text='Stock Status' />
                  <MenuItem to='ledger' icon={<FaMoneyBillWave />} text='Client Ledger' />
                  <MenuItem to='duelist' icon={<FaClipboardList />} text='Due/Recovery List' />
                  <MenuItem onClick={handlePbalanceReport} icon={<FaUsers />} text='Overall Receivable By Customer' />
                  <MenuItem onClick={handleOverallRecievableBySalesman} icon={<FaUserCircle />} text='Overall Receivable By Salesman' />
                  <MenuItem to='sectorsalepbalance' icon={<FaMapMarkerAlt />} text='Region Sale With Previous Balance' />
                  <MenuItem to='subsectorsalepbalance' icon={<FaMapMarkerAlt />} text='Location Sale With Previous Balance' />
                  <MenuItem to='/due/sector/report' icon={<FaChartBar />} text='Region Due Report' />
                  <MenuItem to='/brand/purchase/report' icon={<FaTruck />} text='Purchase Report' />
                  <MenuItem to='/monthlyexpensereport' icon={<FaMoneyBillWave />} text='Monthly Expense Report' />
                  <MenuItem to='showstockdayclose' icon={<FaClipboardList />} text='Show Day Closing' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Registration Module */}
            <Accordion.Item eventKey="0" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaUsers className='accordion-icon' />
                  <span>Registration Module</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='/userslist' icon={<FaUserCircle />} text='Add Users' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Sale Return */}
            <Accordion.Item eventKey="10" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaExchangeAlt className='accordion-icon' />
                  <span>Sale Return</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='/salereturn' icon={<FaExchangeAlt />} text='Sale Return' />
                  <MenuItem to='/alldeletedsaleinvoices' icon={<FaFileInvoice />} text='All Invoices' />
                  <MenuItem to='/salereturnhistory' icon={<FaBoxes />} text='Return Stock' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Purchase Management */}
            <Accordion.Item eventKey="6" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaTruck className='accordion-icon' />
                  <span>Purchase Management</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='/purchase/entry/invoice' icon={<FaFileInvoice />} text='Add Purchase Invoice' />
                  <MenuItem to='all/purchase/invoices' icon={<FaShoppingCart />} text='All Purchase Invoices' />
                  <MenuItem to='/return/purhcase/invoice' icon={<FaExchangeAlt />} text='Return Purchase' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Bank Detail */}
            <Accordion.Item eventKey="1" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaMoneyBillWave className='accordion-icon' />
                  <span>Bank Detail</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='openingbalance' icon={<FaCalculator />} text='Add Opening Balance' />
                  <MenuItem to='recievepayment' icon={<FaMoneyBillWave />} text='Receive Payments' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Company Detail */}
            <Accordion.Item eventKey="2" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaBuilding className='accordion-icon' />
                  <span>Company Detail</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='systemstore' icon={<FaStore />} text='Add Store' />
                  <MenuItem to='systeminvoice' icon={<FaFileInvoice />} text='Add Invoice Detail' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Location Detail */}
            <Accordion.Item eventKey="3" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaMapMarkerAlt className='accordion-icon' />
                  <span>Location Detail</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='addsector' icon={<FaMapMarkerAlt />} text='Add Region' />
                  <MenuItem to='addsubsector' icon={<FaMapMarkerAlt />} text='Add City' />
                  <MenuItem to='assignsector' icon={<FaUsers />} text='Assign City To Customer' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Products Management */}
            <Accordion.Item eventKey="4" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaBoxes className='accordion-icon' />
                  <span>Products Management</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to="/add/category" icon={<FaBoxes />} text='Add Category' />
                  <MenuItem to='/add/product' icon={<FaBoxes />} text='Add Product' />
                  <MenuItem to='/gen/barcode' icon={<FaClipboardList />} text='Gen Barcode' />
                  <MenuItem to='/import/products' icon={<FaFileExport />} text='Import Product' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Special Invoices */}
            <Accordion.Item eventKey="7" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaFileInvoice className='accordion-icon' />
                  <span>Special Invoices</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='autoname' icon={<FaFileInvoice />} text='Special Invoice Names' />
                  <MenuItem to='settingautoname' icon={<FaCalculator />} text='Setting Special Invoice' />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            {/* Expense Sheet */}
            <Accordion.Item eventKey="9" className='accordion-item-custom'>
              <Accordion.Header>
                <div className='accordion-header-content'>
                  <FaMoneyBillWave className='accordion-icon' />
                  <span>Expense Sheet</span>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className='menu-list'>
                  <MenuItem to='/expensesheet' icon={<FaMoneyBillWave />} text='Add Monthly Expense' />
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </OffcanvasBody>

        <style>{`
          .sidebar-offcanvas {
            width: 350px !important;
          }
          
          .sidebar-header {
            background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
            color: white;
            padding: 20px;
          }
          
          .header-title {
            display: flex;
            align-items: center;
            gap: 12px;
            font-size: 18px;
            font-weight: 600;
          }
          
          .header-icon {
            font-size: 24px;
          }
          
          .sidebar-body {
            padding: 20px 15px;
            background: #f8f9fc;
          }
          
          .custom-accordion {
            --bs-accordion-bg: transparent;
            --bs-accordion-border-color: none;
          }
          
          .accordion-item-custom {
            margin-bottom: 12px;
            border: none;
            border-radius: 12px !important;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          }
          
          .accordion-header-content {
            display: flex;
            align-items: center;
            gap: 12px;
            font-weight: 600;
            color: #1e3c72;
          }
          
          .accordion-icon {
            font-size: 18px;
          }
          
          .menu-list {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
          
          .menu-item {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 12px;
            color: #555;
            font-size: 14px;
            border-radius: 8px;
            transition: all 0.3s ease;
            cursor: pointer;
          }
          
          .menu-item:hover {
            background: linear-gradient(135deg, rgba(30,60,114,0.1) 0%, rgba(42,82,152,0.1) 100%);
            transform: translateX(5px);
            color: #1e3c72;
          }
          
          .menu-item svg {
            font-size: 16px;
            min-width: 20px;
          }
          
          /* Override Bootstrap accordion styles */
          :global(.accordion-button) {
            background: white !important;
            padding: 15px 20px !important;
            font-weight: 600 !important;
          }
          
          :global(.accordion-button:not(.collapsed)) {
            background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%) !important;
            color: white !important;
          }
          
          :global(.accordion-button:not(.collapsed) .accordion-header-content) {
            color: white !important;
          }
          
          :global(.accordion-button:focus) {
            box-shadow: none !important;
            border-color: none !important;
          }
          
          :global(.accordion-body) {
            padding: 15px !important;
            background: #f8f9fc !important;
          }
          
          @media (max-width: 768px) {
            .sidebar-offcanvas {
              width: 280px !important;
            }
            
            .menu-item {
              font-size: 13px;
            }
          }
        `}</style>
      </Offcanvas>
    </div>
  )
}

export default Sidebar